import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { CreditAccountResponse } from './types';

type GetCreditAccountProps = {
  artistId: string;
};

export const getCreditAccount = async ({ artistId }: GetCreditAccountProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/credits/account`;

  const response = await api.executeGetRequest<ObjectResponse<CreditAccountResponse>>(url);

  return response.data;
};
